// it translations — extracted mechanically from LanguageContext.jsx (Team Foundation).
// Feature-specific keys belong in src/i18n/extensions/*.js instead.
const it = {
    // Common
    "common.loading": "Caricamento...",
    "common.save": "Salva",
    "common.cancel": "Annulla",
    "common.delete": "Elimina",
    "common.edit": "Modifica",
    "common.submit": "Invia",
    "common.logout": "Esci",
    "common.login": "Accedi",
    "common.register": "Registrati",
    
    // Auth
    "auth.welcome": "Benvenuto",
    "auth.signIn": "Accedi al tuo account",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.loginButton": "Accedi",
    
    // Navigation
    "nav.dashboard": "Dashboard",
    "nav.releases": "Uscite",
    "nav.payouts": "Pagamenti",
    "nav.support": "Supporto",
    "nav.referrals": "Referral",
    "nav.profile": "Profilo",
    
    // Dashboard
    "dashboard.welcome": "Benvenuto",
    "dashboard.subtitle": "Gestisci la tua musica, monitora le tue uscite e visualizza i tuoi guadagni.",
    "dashboard.totalReleases": "Uscite Totali",
    "dashboard.totalTracks": "Tracce Totali",
    "dashboard.balance": "Saldo Attuale",
    "dashboard.withdrawable": "Prelevabile",
    "dashboard.recentReleases": "Uscite Recenti",
    "dashboard.newRelease": "Nuova Uscita",
    "dashboard.requestPayout": "Richiedi Pagamento",
    
    // Analytics
    "analytics.title": "Statistiche",
    "analytics.subtitle": "Monitora le prestazioni delle tue uscite",
    "analytics.totalStreams": "Stream Totali",
    "analytics.listeners": "Ascoltatori",
    "analytics.estimatedEarnings": "Guadagni Stimati",
    "analytics.monthlyGrowth": "Crescita Mensile",
    "analytics.streamsChart": "Grafico Stream",
    "analytics.platformDistribution": "Distribuzione Piattaforme",
    "analytics.topTracks": "Tracce Popolari",
    "analytics.trackName": "Nome Traccia",
    "analytics.streams": "stream",
    "analytics.comingSoonTitle": "Prossimamente",
    "analytics.comingSoonDesc": "Analisi dettagliate e statistiche saranno presto disponibili. Con l'integrazione artist.tools, potrai monitorare tutti i dati delle piattaforme in un unico posto.",
    "common.comingSoon": "Prossimamente",
    
    // Payouts
    "payouts.title": "Gestisci i Tuoi Guadagni",
    "payouts.subtitle": "Preleva facilmente i tuoi guadagni musicali. Richiedi un pagamento con un minimo di $50.",
    "payouts.fastPayment": "Pagamento veloce",
    "payouts.secureTransfer": "Trasferimento sicuro",
    "payouts.totalBalance": "Saldo Totale",
    "payouts.withdrawableBalance": "Prelevabile",
    "payouts.requestPayout": "Richiedi Pagamento",
    "payouts.payoutHistory": "Storico Pagamenti",
    "payouts.noPayouts": "Nessuna richiesta di pagamento",
    "payouts.noPaymentMethod": "Nessun Metodo di Pagamento",
    "payouts.addMethodDesc": "Aggiungi un metodo di pagamento per prelevare i tuoi guadagni.",
    "payouts.addMethod": "Aggiungi Metodo di Pagamento",
    "payouts.changeMethodVerification": "Verifica email richiesta per modificare il metodo di pagamento attuale",
    "payouts.availableBalance": "Saldo Disponibile",
    "payouts.pendingBalance": "Saldo in Attesa",
    "payouts.withdrawalHistory": "Storico Prelievi",
    "payouts.requestWithdrawal": "Richiedi Prelievo",
    "payouts.minWithdrawal": "Prelievo minimo: $50",
    "payouts.manageEarnings": "Gestisci i tuoi guadagni",
    "payouts.createRequest": "Crea Richiesta di Pagamento",
    "payouts.amount": "Importo",
    "payouts.accountHolder": "Intestatario Conto",
    "payouts.bankName": "Nome Banca",
    "payouts.minAmount": "L'importo minimo di prelievo è $50",
    "payouts.insufficientBalance": "Saldo insufficiente",
    "payouts.fillRequired": "Compila tutti i campi obbligatori",
    "payouts.requestCreated": "Richiesta di pagamento creata",
    "payouts.requestFailed": "Richiesta fallita",
    "payouts.minNotMet": "Minimo non raggiunto",
    "payouts.minNotMetMsg": "Hai bisogno di almeno $50 di saldo prelevabile per richiedere un pagamento.",
    "payouts.statusRequested": "Richiesto",
    "payouts.statusPaid": "Pagato",
    "payouts.paymentMethod": "Metodo di Pagamento",
    "payouts.bankTransfer": "Bonifico Bancario",
    "payouts.paypalEmail": "Email PayPal",
    "payouts.paypalNote": "Inserisci l'indirizzo email associato al tuo account PayPal",
    "payouts.fillPaypalRequired": "Inserisci email PayPal e nome intestatario",
    "payouts.selectCountry": "Seleziona il tuo paese",
    "payouts.tabProfile": "Profilo di Pagamento",
    "payouts.tabMethod": "Metodo di Pagamento",
    "payouts.tabRequests": "Richieste di Prelievo",
    "payouts.requirements": "Requisiti per il Prelievo",
    "payouts.completeProfile": "Completa il tuo profilo di pagamento (Identità e Indirizzo)",
    "payouts.addPaymentMethod": "Aggiungi un metodo di pagamento (Banca o PayPal)",
    "payouts.verifyPaymentMethod": "Verifica il tuo metodo di pagamento",
    "payouts.profileComplete": "Completato",
    "payouts.savedProfile": "Informazioni Profilo Salvate",
    "payouts.fullName": "Nome Completo",
    "payouts.phoneNumber": "Telefono",
    "payouts.location": "Posizione",
    "payouts.profileType": "Tipo di Profilo",
    "payouts.individual": "Individuale",
    "payouts.business": "Azienda/Impresa",
    "payouts.edit": "Modifica",
    
    // Statuses
    "status.draft": "Bozza",
    "status.submitted": "Inviato",
    "status.approved": "Approvato",
    "status.rejected": "Rifiutato",
    "status.live": "Online",
    
    // Validation
    "validation.audioRequired": "Il file audio è obbligatorio",
    "validation.audioFormatWav": "Il file audio deve essere in formato WAV o FLAC",
    "validation.titleRequired": "Il titolo è obbligatorio",
    "validation.titleLanguageRequired": "La lingua del titolo è obbligatoria",
    "validation.primaryArtistRequired": "È richiesto almeno un artista principale",
    "validation.primaryGenreRequired": "La selezione del genere principale è obbligatoria",
    "validation.explicitRequired": "La selezione del tipo di contenuto è obbligatoria",
    "validation.coverRequired": "L'immagine di copertina è obbligatoria",
    "validation.songwriterRequired": "È richiesto almeno un autore",
    "validation.contributorRequired": "È richiesto almeno un collaboratore",
    "validation.productionTeamRequired": "È richiesto almeno un membro del team di produzione",
    "validation.platformRequired": "È necessario selezionare almeno una piattaforma",
    "validation.releaseDateRequired": "La data di uscita è obbligatoria",
    "validation.trackCountRequired": "Sono necessarie almeno 2 tracce per EP/Album",
    "releases.track": "Traccia",
    
    // Toast Messages
    "toast.saveSuccess": "Salvato con successo",
    "toast.saveFailed": "Salvataggio fallito",
    "toast.deleteSuccess": "Eliminato con successo",
    "toast.uploadSuccess": "Caricato con successo",
    "toast.submitSuccess": "Inviato con successo",
    "toast.loginSuccess": "Accesso effettuato",
    "toast.copySuccess": "Copiato negli appunti",
    "toast.errorOccurred": "Si è verificato un errore",
    "toast.pleaseFixErrors": "Correggi gli errori in questa sezione",
    
    // Spotify
    "spotify.comingSoon": "Prossimamente",
};

export default it;
